import request from '@/utils/request'
/*权限*/
let AuthUserApi = {
  /*获取当前角色权限*/
  getRoleList(data) {
    return request._post('/shop/auth_app.user/getRoleList', data);
  },
  /*获取角色信息*/
  getUserInfo(data) {
    return request._post('/shop/auth_app.user/getUserInfo', data);
  },
  /*角色列表*/
  roleList(data) {
    return request._post('/shop/auth_app.role/index', data);
  },
  /*管理员列表*/
  userList(data) {
    return request._post('/shop/auth_app.user/index', data);
  },
  /*添加管理员需要的数据*/
  userAddInfo(data) {
    return request._get('/shop/auth_app.user/add', data);
  },
  /*添加管理员*/
  userAdd(data) {
    return request._post('/shop/auth_app.user/add', data);
  },
 /*修改管理员需要的数据*/
  userEditInfo(data) {
    return request._get('/shop/auth_app.user/edit', data);
  },
  /*修改管理员*/
  userEdit(data) {
    return request._post('/shop/auth_app.user/edit', data);
  },
  /*删除管理员*/
  userDelete(data) {
    return request._post('/shop/auth_app.user/delete', data);
  },
}
export default AuthUserApi;



// WEBPACK FOOTER //
// ./src/api/authuser.js